export const MasonryBreakPoints = {
        default: 2,
        1400: 2,
        1200: 1,
        900: 1,
}